var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCyprus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0439 13.9131C24.557 13.9131 23.954 13.9131 22.957 13.9131C22.957 17.7551 19.8423 20.8696 16.0005 20.8696C12.1584 20.8696 9.04397 17.7551 9.04397 13.9131C8.37147 13.9131 7.62941 13.9131 6.95703 13.9131C6.95703 18.0515 9.73678 21.5407 13.5312 22.6153C13.1152 23.4055 13.1785 24.4005 13.7728 25.142C14.5533 24.5165 15.3613 23.8689 16.0468 23.3196C16.7323 23.869 17.5405 24.5165 18.3209 25.142C18.921 24.3931 18.9801 23.3855 18.5503 22.5915C22.3031 21.4905 25.0439 18.0221 25.0439 13.9131Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 13.2175C10.4348 13.2175 10.4348 16.6957 13.9131 16.6957L14.6087 17.3913H16C16 17.3913 16.6956 15.3044 18.0869 15.3044C18.0869 15.3044 18.0869 13.9131 19.4783 13.9131C20.8696 13.9131 21.5652 13.9131 21.5652 13.9131C21.5652 13.9131 20.8696 11.1305 24.3478 9.04353L22.9565 8.3479C22.9565 8.3479 18.0869 11.8262 14.6087 11.1305V12.5218H13.2174L12.5218 11.8262L10.4348 13.2175Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCyprus);
export default __webpack_public_path__ + "static/media/flag_cyprus.470d64412b103210ce23ca53dfcc2bde.svg";
export { ForwardRef as ReactComponent };